import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SortingState } from '@tanstack/react-table'

export interface TablePagination {
    pageIndex: number;
    pageSize: number;
    totalData: number;
    refreshTrigger: boolean;
    filterData: number;
    searchParams: { [key: string]: string };
    sorting: SortingState
}
interface PaginationState {
    [tableKey: string]: TablePagination;
}

export const initialPaginationState: PaginationState = {
    manage_user: {
        pageIndex: 0,
        pageSize: 10,
        totalData: 0,
        refreshTrigger: false,
        filterData: 0,
        searchParams: {},
        sorting: []
    },
    analysis_history: {
        pageIndex: 0,
        pageSize: 10,
        totalData: 0,
        refreshTrigger: false,
        filterData: 0,
        searchParams: {},
        sorting: []
    },
    transactionHistoryList: {
        pageIndex: 0,
        pageSize: 10,
        totalData: 0,
        refreshTrigger: false,
        filterData: 0,
        searchParams: {},
        sorting: []
    },
    user_analysis_history: {
        pageIndex: 0,
        pageSize: 10,
        totalData: 0,
        refreshTrigger: false,
        filterData: 0,
        searchParams: {},
        sorting: []
    },
    subscription_list: {
        pageIndex: 0,
        pageSize: 10,
        totalData: 0,
        refreshTrigger: false,
        filterData: 0,
        searchParams: {},
        sorting: []
    },
    self_exclusion_list: {
        pageIndex: 0,
        pageSize: 10,
        totalData: 0,
        refreshTrigger: false,
        filterData: 0,
        searchParams: {},
        sorting: []
    }
}

const paginationSlice = createSlice({
    name: 'pagination',
    initialState: initialPaginationState,
    reducers: {
        setPageIndex: (state, action: PayloadAction<{ table: string; pageIndex: number }>) => {
            state[action.payload.table].pageIndex = action.payload.pageIndex
        },
        setPageSize: (state, action: PayloadAction<{ table: string; pageSize: number }>) => {
            state[action.payload.table].pageSize = action.payload.pageSize
        },
        setTotalRecords: (state, action: PayloadAction<{ table: string; totalData: number }>) => {
            state[action.payload.table].totalData = action.payload.totalData
        },
        setFilterRecords: (state, action: PayloadAction<{ table: string; filterData: number }>) => {
            state[action.payload.table].filterData = action.payload.filterData
        },
        triggerRefresh: (state, action: PayloadAction<{ table: string; isRefresh: boolean }>) => {
            state[action.payload.table].refreshTrigger = action.payload.isRefresh
        },
        setSearchParam: (state, action: PayloadAction<{ table: string; key: string; value: string }>) => {
            state[action.payload.table].searchParams[action.payload.key] = action.payload.value
        },
        setSorting: (state, action: PayloadAction<{ table: string, sorting: SortingState }>) => {
            state[action.payload.table].sorting = action.payload.sorting
        },
        resetPagination: (state, action: PayloadAction<{ table: string }>) => {
            const tableKey = action.payload.table
            if (initialPaginationState[tableKey]) {
                state[tableKey] = { ...initialPaginationState[tableKey] }
            }
        }
    }
})

export const { setPageIndex, setPageSize, setTotalRecords, triggerRefresh, setFilterRecords, setSearchParam, setSorting, resetPagination } = paginationSlice.actions
export default paginationSlice.reducer
